<template>
  <grid
    :model=SupplierModel
    :endpoint='api.$.network.insuranceSuppliers'
    :default-view='defaultView'
    name='Manage Insurance'
    desc='Check Supplier Certificates'
    search-placeholder='Suppliers'
    fit-columns
    :checkboxes="false"
    :search="true"
    :resizing="false"
    xviews="false"
    footer
    ref='InsuranceSuppliersGrid'
    alias='InsuranceSuppliersGrid-'
    export-uri='InsuranceAvailableSuppliers/ExportList'
  />
</template>

<script>

import Grid from '@/components/Grid'
import SupplierModel from './models/supplier-model.js'
// import tabs from './tabs'

export default {
  components: {
    Grid
  },

  data () {
    return {
      SupplierModel,
      defaultView: {
        label: 'Pending Certificates',
        filter: { ShouldBeVerified: 'Yes' },
        icon: 'far fa-clock'
      }
      // tabs: tabs.tabs
    }
  },

  activated() {
    if (!this.created) {
      this.$refs.InsuranceSuppliersGrid.quickSearch()
    }
  },
  deactivated() {
    this.created = false
  },

  created() {
    this.created = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Network/Insurance/suppliers.vue